/**
 * Madam Muse: keep Intelligems test prices applied after Horizon morphs the price DOM
 * (variant change, quick add, section re-render). Safe no-op when no price test is running.
 * Uses the documented Intelligems JS API: window.igData.price.getPriceByVariantId(id).
 */
(function () {
  const money = (cents) => {
    try {
      const fmt = window.mmMoneyFormat || '{{amount}}';
      const amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount\s*\}\}/, amount);
    } catch (e) {
      return null;
    }
  };

  const apply = () => {
    const ig = window.igData && window.igData.price;
    if (!ig || typeof ig.getPriceByVariantId !== 'function') return;
    document.querySelectorAll('[ref="priceContainer"][data-variant-id]').forEach((el) => {
      const id = el.getAttribute('data-variant-id');
      const price = ig.getPriceByVariantId(id);
      if (price == null) return;
      const node = el.querySelector('.price');
      const text = money(price);
      if (node && text && node.textContent.trim() !== text) node.textContent = text;
      const compare = ig.getComparePriceByVariantId ? ig.getComparePriceByVariantId(id) : null;
      const cnode = el.querySelector('.compare-at-price');
      if (cnode && compare != null) {
        const ctext = money(compare);
        if (ctext && cnode.textContent.trim() !== ctext) cnode.textContent = ctext;
      }
    });
  };

  const schedule = () => window.requestAnimationFrame(apply);
  const ready = () => {
    schedule();
    document.addEventListener('variant:selected', schedule);
    document.addEventListener('variant:update', schedule);
    document.addEventListener('cart:update', schedule);
    document.addEventListener('shopify:section:load', schedule);
    const mo = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type === 'childList' && m.addedNodes.length) { schedule(); break; }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  };

  if (window.igData) ready();
  else window.addEventListener('ig:ready', ready, { once: true });
})();
